<template>
  <div class="multiple-cascader">    
    <el-form-item 
      v-for="i in data.length" 
      :key="i">
      <template slot="label">
        {{ title(i) }}
        <a 
          v-if="i > 1" 
          href="#" 
          @click.prevent="moveUp(i - 1)">
          <i class="el-icon-fa-arrow-up" />
        </a>
        <a 
          v-if="i < data.length" 
          href="#" 
          @click.prevent="moveDown(i - 1)">
          <i class="el-icon-fa-arrow-down" />
        </a>
        <a 
          v-if="data.length > min" 
          href="#" 
          @click.prevent="remove(i - 1)">
          <i class="el-icon-fa-trash" />
        </a>
      </template>
      <el-cascader
        v-model="data[i - 1].value"
        :options="source"
        :filterable="true"
        :props="props"
        :clearable="clearable"
        @active-item-change="load"
        @change="emit" />
      <el-radio-group
        v-for="opt in valueOptions"
        :key="opt.key" 
        v-model="data[i - 1].options[opt.key]">
        <el-radio 
          v-for="o in opt.options" 
          :key="o.key" 
          :label="o.key">
          {{ o.label }}
        </el-radio>
      </el-radio-group>
      <slot name="more" :data="fullData(data[i - 1])" :internal="data[i - 1]" :i="i - 1" />
    </el-form-item>
    <el-button
       type="success"
       icon="el-icon-plus"
       class="add-more"
       size="mini"
       :disabled="!valid || (!!max && data.length >= max)"
       @click="add">
      {{ addText }}
    </el-button>
  </div>
</template>

<style scoped>
.multiple-cascader {
    margin-bottom: 20px;
}
.el-cascader {
    width: 100%;
}
.add-more {
    margin-top: 10px;
}
</style>
<style>
.multiple-cascader .el-form-item__label {
  float: none;
}

</style>

<script>
import customGraphApiAware from './mixins/customGraphApiAware'
import api from './api'

export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    addText: {
      type: String,
      default: 'Ajouter'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    title: {
      type: Function,
      default: i => {
        return 'Valeur ' + i
      }
    },
    props: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          value: 'value',
          children: 'children'
        }
      }
    },
    loadChildren: {
      type: Function,
      default: () => {
        return () => ({})
      }
    },
    createNew: {
      type: Function,
      default: () => {
        return {}
      }
    },
    options: {
      type: Array,
      required: true
    },
    valueOptions: {
      type: Array,
      default: () => []
    },
    getHierarchy: {
      type: Function,
      default: v => [
        api.measure.uniqueName(v).split('].[')[0] + ']',
        api.measure.uniqueName(v),
      ]
    }
  },
  mixins: [
    customGraphApiAware
  ],
  data () {
    return {
      data: Array.from(new Array(this.min), () => this.newVal()),
      source: this.options.slice(),
      sourceKeys: {}
    }
  },
  computed: {
    valid () {
      for (const d of this.data) {
        if (!d.value.length) {
          return false
        }
        for (const k of Object.keys(d.options)) {
          if (d.options[k] === null) {
            return false
          }
        }
      }
      return true
    }
  },
  watch: {
    options () {
      this.source.splice(0, this.source.length, ...this.options)
    },
    value () {
      this.updateData()
    },
    valid () {
      this.emit()
    }
  },
  mounted () {
    this.updateData()
  },
  methods: {
    add () {
      this.data.push(this.newVal())
    },
    remove (i) {
      this.data.splice(i, 1)
      this.emit()
    },
    moveUp (i) {
      this.data.splice(i - 1, 0, this.data.splice(i, 1)[0])
      this.emit()
    },
    moveDown (i) {
      this.data.splice(i + 1, 0, this.data.splice(i, 1)[0])
      this.emit()
    },
    load (keys) {
      this.loadChildren(this.recursiveFind(keys.slice(-1)[0], this.source), this.source)
    },
    emit () {
      if (this.valid) {
        this.$emit('input', this.data.map(d => this.fullData(d)))
      }
    },
    recursiveFind (key, source) {
      for (const d of source) {
        if (d[this.props.value] === key) {
          return d
        }
        if (typeof d.children !== 'undefined') {
          const r = this.recursiveFind(key, d.children)
          if (typeof r !== 'undefined') {
            return r
          }
        }
      }
    },
    newVal () {
      const options = {}
      this.valueOptions.forEach(o => {
        options[o.key] = null
      })
      const response = {
        value: [],
        options: options,
      }
      const more = this.createNew()
      Object.keys(more).forEach(k => {
        response[k] = more[k]
      })
      return response
    },
    updateData () {
      if (!this.value) {
        this.data.splice(0)
      } else {
        this.data.splice(0, this.value.length, ...this.value.map(v => {
          const response = this.createNew()
          Object.keys(v).forEach(k => {
            if (k === 'value') {
              response[k] = this.getHierarchy(v.value)
            } else {
              response[k] = v[k]
            }
          })
          return response
        }))
      }
    },
    fullData (data) {
      const response = this.createNew()
      Object.keys(data).forEach(k => {
        if (k === 'value') {
          response.value = this.recursiveFind(data.value.slice(-1)[0], this.source)
        } else {
          response[k] = data[k]
        }
      })
      return response
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/MultipleCascader.vue